(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-content"] && !Shopify.designMode) return;
  try {
    class CollapsibleContent extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('button');
      this.content = this.querySelector(`#${this.toggleButton.getAttribute('aria-controls')}`);

      this.toggleButton.addEventListener('click', () => {
        const isExpanded = this.toggleButton.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          this.closeContent();
        } else {
          this.openContent();
        }
      });
    }

    openContent() {
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.content.setAttribute('aria-hidden', 'false');
    }

    closeContent() {
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.content.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('collapsible-content', CollapsibleContent);
  } catch(e) { console.error(e); }
})();

})();
